import React from 'react'
import { format } from 'date-fns'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { LGYAddress } from 'app/components/util/lgy-field/LgyField'
import { formatPhone, formatDollars } from '../common/AssignmentUtils'

const NovSarInfoSection = ({ assignmentDetails }) => {
  const phoneNumberFieldValue = (assignmentDetails.sarPhoneNumber ? formatPhone(assignmentDetails.sarPhoneNumber) : '') + (assignmentDetails.sarPhoneNumberExt ? ` Ext. ${assignmentDetails.sarPhoneNumberExt}` : '')
  const sarNameAndIdFieldValue = (assignmentDetails.sarName && assignmentDetails.sarId) ? `${assignmentDetails.sarName} – ${assignmentDetails.sarId}` : ''
  return (
    <LgySubsection header='NOV/SAR Information' className='assignment-details-child'>
      <table>
        <caption className='usa-sr-only'>NOV/SAR Information</caption>
        <tbody>
          <tr>
            <th scope='row'>Est. reasonable value:</th>
            <td>{`$${formatDollars(assignmentDetails.reasonableValueAmount)}`}</td>
          </tr>
          <tr>
            <th scope='row'>CRV/NOV expiration date:</th>
            <td>{assignmentDetails.novExpirationDate ? format(assignmentDetails.novExpirationDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true }) : ''}</td>
          </tr>
          <tr>
            <th scope='row'>NOV issue date:</th>
            <td>{assignmentDetails.dispositionCode === 'I' && format(assignmentDetails.currentDispositionDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
          </tr>
          <tr>
            <th scope='row'>SAR name and ID:</th>
            <td>{sarNameAndIdFieldValue}</td>
          </tr>
          <tr>
            <th scope='row'>Address:</th>
            <td>
              <LGYAddress
                streetAddress1={assignmentDetails.sarAddressOne}
                streetAddress2={assignmentDetails.sarAddressTwo}
                city={assignmentDetails.sarCityName}
                state={assignmentDetails.sarStateCode}
                zip={assignmentDetails.sarZipPrefixNumber}
                zipSuffix={assignmentDetails.sarZipFirstSuffix} />
            </td>
          </tr>
          <tr>
            <th scope='row'>Phone number:</th>
            <td>{phoneNumberFieldValue}</td>
          </tr>
          <tr>
            <th scope='row'>Email:</th>
            <td>{assignmentDetails.sarEmail}</td>
          </tr>
        </tbody>
      </table>
    </LgySubsection>
  )
}

export default NovSarInfoSection
